import { convert_date_to_timestamp,  get_last_day_of_month, get_last_day_of_year } from './dates'

function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}

export function filter(activeFilters, activeFilter, results){
  console.log(results)
  results = results.filter(function(res){
    if (typeof res.success != "undefined"){
      return false;
    }
    return true;
  })

  if (activeFilter.type == "date" ){
    //date picker


    if (!activeFilter.value[0])
      return results;

    let start_date = convert_date_to_timestamp(activeFilter.value[0]);
    let end_date = false;

    if (activeFilter.value[1]) {
      end_date = convert_date_to_timestamp(activeFilter.value[1]);
    }



    results = results.filter(function(res){

      if (isEmpty(res.performances))
        return false;



      let has_performances = false;

      for (const property in res.performances) {
        let performance_date = parseInt(res.performances[property]) * 1000;

        performance_date = new Date(performance_date).setHours(0, 0, 0, 0) / 1000;


        if (end_date ){

          if ( parseInt(performance_date) >=  start_date && parseInt(performance_date) <=  end_date ){
            has_performances = true;
          }
        } else {
          if ( parseInt(performance_date) >=  start_date){
            has_performances = true;
          }
        }
      }



      return has_performances;


    })

  }


  if (activeFilter.type == "search" && activeFilter.value.length){
    results  = results.filter(result => {
      if (typeof(result.search) != "undefined"){
        return result.search.toLowerCase().indexOf(activeFilters.search.value.toLowerCase()) > -1 || !activeFilters.search.value.length
      }
      return false;
    });

  }

  if (activeFilter.type == "checkbox" && activeFilter.value.length){
    if (!Array.isArray(activeFilter.value)){
      activeFilter.value = [activeFilter.value];
    }

    results  = results.filter(result => {
       
      if (typeof result[activeFilter.name] == "undefined" || !result[activeFilter.name].length)
        return false;
    
      return activeFilter.value.some(x => result[activeFilter.name].includes(x))

      // if (typeof result == "undefined" || typeof result[activeFilter.name.toLowerCase()] == "undefined" || !result[activeFilter.name.toLowerCase()].length)
      //   return false;
      //
      //
      //
      //
      // return activeFilter.value.some(x => result[activeFilter.name.toLowerCase()].includes(x))

    });
  }

  return results;
}


export function filter_items(results, activeFilters) {

  let and_count = 0;

  for (const key in activeFilters) {

    let filtered_results = [];
    if (activeFilters.hasOwnProperty(key)) {
      const activeFilter = activeFilters[key];
      // if (!activeFilter.or && activeFilter.value.length){
      if (!activeFilter.or ){

        and_count++;

        results = filter(activeFilters, activeFilter, results);
      }

    }
  }

  let final_results = results;
  let or_results = [];
  let or_count = 0;


  for (const key in activeFilters) {

    if (activeFilters.hasOwnProperty(key)) {

      const activeFilter = activeFilters[key];

      if (activeFilter.or && activeFilter.value.length){
        or_count++;

        let or_result = filter(activeFilters, activeFilter, final_results);

        if (or_count > 0){
          or_results = [...new Set([...or_results, ...or_result])];
        } else {
          or_results = or_result;
        }

        final_results = or_results;
      }

    }
  }


  return final_results;
}
